export function authHeader() {
  let token = localStorage.getItem("token") || "";

  if (token !== "") {
    return "Bearer " + token;
  } else {
    return "";
  }
}

export function getCurrentUser() {
  const user = localStorage.getItem("currentUser");
  return user ? JSON.parse(user) : null;
}
